import { Role, RoleAction } from "src/Api/Enum/Role";
import type { TableNameType } from "../table";

export type CustomerPermission = {
  id: string;
  name: string;
  key: string;
  customerId: string;
  allowedRoles?: string[];
  metadata?: {
    areas?: string[];
    overviewName?: string;
    defaultArea?: string;
    locHierCategoryId?: string;    // usato nella chiamata a /hierarchicalcategory/hierid/:id per ottenere la mappa id->nome delle aree
    pomCategoryFilter?: string[];  // (non gestito qui)
    locAreaFilter?: boolean;       //  (non gestito qui)
    kpiKey?: string;               //  (non gestito qui)
    kpiSource?: string;            //  (non gestito qui)
  };
};
export type Permission = {
  action: RoleAction;
  limit: string[];
  isCustomerFeature: boolean;
};

export type TablePermission = Partial<Record<TableNameType, Permission[]>>;

export function isFeatureVisibleForRole(
  feature: CustomerPermission | undefined,
  userRoles: string[] = [],
): boolean {
  if (!feature) return false;
  const { allowedRoles } = feature;
  if (!allowedRoles || allowedRoles.length === 0) return false;
  return userRoles.some((role) => allowedRoles.includes(role));
}

export abstract class PermissionFactory {
  static buildPermission(action: RoleAction, limit: string[] = []): Permission {
    return {
      action,
      limit,
      isCustomerFeature: false,
    };
  }

  static buildFeaturePermission(
    action: RoleAction,
    featureKey: string,
    customerPermissions: CustomerPermission[] = [],
    userRoles: string[] = [],
    limit: string[] = []
  ): Permission {
    const feature = customerPermissions.find(
      (perm) => perm.key.toUpperCase() === featureKey.toUpperCase()
    );
    return {
      action,
      limit,
      isCustomerFeature: isFeatureVisibleForRole(feature, userRoles),
    };
  }


  static isCustomerAllowed(permissions?: TablePermission): boolean {
    if (!permissions) return false;

    const welcomePagePerms: Permission[] | undefined = permissions.welcomePage;

    if (!welcomePagePerms) return false;

    return welcomePagePerms.some(
      (perm) => perm.action === RoleAction.SUMMARY_REPORT && perm.isCustomerFeature
    );
  }
}

export const CRUD = [
  PermissionFactory.buildPermission(RoleAction.VIEW),
  PermissionFactory.buildPermission(RoleAction.CREATE),
  PermissionFactory.buildPermission(RoleAction.UPDATE),
  PermissionFactory.buildPermission(RoleAction.DELETE),
];

export const VIEW_ONLY = [PermissionFactory.buildPermission(RoleAction.VIEW)];